//import React, { useState, useEffect, useRef } from "react";
//import { Link } from "react-router-dom";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faSync } from "@fortawesome/free-solid-svg-icons";
//import HoaTermsConditions from "../HoaTermsConditions/HoaTermsConditions";
//import axios from "axios";
//import { API_URL } from "../../apiConfig";
//import PhoneInput from 'react-phone-input-2';
//import 'react-phone-input-2/lib/style.css';

//const HoaContact = () => {
//  const [showModal, setShowModal] = useState(false);
//  const [userInput, setUserInput] = useState("");
//  const [isChecked, setIsChecked] = useState(false);
//  const [captchaText, setCaptchaText] = useState("");
//  const canvasRef = useRef(null);
//  const [formData, setFormData] = useState({
//    fullName: "",
//    email: "",
//    phoneNumber: "",
//    message: "",
//    termsAccepted: false,
//  });

//  const [fullNameError, setFullNameError] = useState("");
//  const [emailError, setEmailError] = useState("");
//  const [phoneNumberError, setPhoneNumberError] = useState("");
//  const [messageError, setMessageError] = useState("");
//  const [captchaError, setCaptchaError] = useState("");
//  const [termsError, setTermsError] = useState("");

//  // Generate captcha text
//  const generateCaptcha = () => {
//    const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
//    let result = '';
//    for (let i = 0; i < 6; i++) {
//      result += characters.charAt(Math.floor(Math.random() * characters.length));
//    }
//    return result;
//  };

//  // Draw captcha on canvas
//  const drawCaptcha = (text) => {
//    const canvas = canvasRef.current;
//    if (!canvas) return;

//    const ctx = canvas.getContext('2d');
//    canvas.width = 200;
//    canvas.height = 60;

//    // Clear canvas
//    ctx.clearRect(0, 0, canvas.width, canvas.height);

//    // Set background
//    ctx.fillStyle = '#f8f9fa';
//    ctx.fillRect(0, 0, canvas.width, canvas.height);

//    // Add noise lines
//    for (let i = 0; i < 5; i++) {
//      ctx.strokeStyle = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.3)`;
//      ctx.lineWidth = Math.random() * 2 + 1;
//      ctx.beginPath();
//      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
//      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
//      ctx.stroke();
//    }

//    // Add noise dots
//    for (let i = 0; i < 50; i++) {
//      ctx.fillStyle = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.4)`;
//      ctx.beginPath();
//      ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 2, 0, 2 * Math.PI);
//      ctx.fill();
//    }

//    // Draw text
//    ctx.font = 'bold 24px Arial';
//    ctx.textAlign = 'center';
//    ctx.textBaseline = 'middle';

//    const textWidth = canvas.width / text.length;
//    for (let i = 0; i < text.length; i++) {
//      const char = text[i];
//      const x = textWidth * i + textWidth / 2;
//      const y = canvas.height / 2 + (Math.random() - 0.5) * 10;

//      // Random color for each character
//      ctx.fillStyle = `rgb(${Math.floor(Math.random() * 100) + 50}, ${Math.floor(Math.random() * 100) + 50}, ${Math.floor(Math.random() * 100) + 50})`;

//      // Random rotation
//      ctx.save();
//      ctx.translate(x, y);
//      ctx.rotate((Math.random() - 0.5) * 0.5);
//      ctx.fillText(char, 0, 0);
//      ctx.restore();
//    }

//    // Add border
//    ctx.strokeStyle = '#dee2e6';
//    ctx.lineWidth = 2;
//    ctx.strokeRect(0, 0, canvas.width, canvas.height);
//  };

//  // Initialize captcha
//  useEffect(() => {
//    const newCaptcha = generateCaptcha();
//    setCaptchaText(newCaptcha);
//  }, []);

//  // Draw captcha when text changes
//  useEffect(() => {
//    if (captchaText) {
//      drawCaptcha(captchaText);
//    }
//  }, [captchaText]);

//  // Validation functions
//  const validateForm = () => {
//    let isValid = true;

//    setFullNameError("");
//    setEmailError("");
//    setPhoneNumberError("");
//    setMessageError("");
//    setCaptchaError("");
//    setTermsError("");

//    // Full Name validation
//    if (formData.fullName.trim() === "") {
//      setFullNameError("Full Name is required");
//      isValid = false;
//    }

//    // Email validation
//    if (!/\S+@\S+\.\S+/.test(formData.email)) {
//      setEmailError("Invalid email address");
//      isValid = false;
//    }

//    // Phone Number validation
//    if (formData.phoneNumber.trim() === "" || formData.phoneNumber.length < 10) {
//      setPhoneNumberError("Phone Number must be at least 10 digits");
//      isValid = false;
//    }

//    // Message validation
//    if (formData.message.trim() === "") {
//      setMessageError("Message is required");
//      isValid = false;
//    }

//    // Captcha validation
//    if (userInput.trim() === "") {
//      setCaptchaError("Captcha is required");
//      isValid = false;
//    } else if (userInput.toLowerCase() !== captchaText.toLowerCase()) {
//      setCaptchaError("Invalid Captcha");
//      isValid = false;
//    }

//    // Terms validation
//    if (!isChecked) {
//      setTermsError("You must accept the Terms & Conditions");
//      isValid = false;
//    }

//    return isValid;
//  };

//  const handleChange = (e) => {
//    const { name, value } = e.target;
//    setFormData({
//      ...formData,
//      [name]: value,
//    });
//  };

//  const handlePhoneNumberChange = (value) => {
//    setFormData({
//      ...formData,
//      phoneNumber: value,
//    });
//  };

//  const handleSubmit = async (e) => {
//    e.preventDefault();

//    if (validateForm()) {
//      try {
//        const response = await axios.post(
//          `${API_URL}/public/contacts/add`,
//          {
//            name: formData.fullName,
//            email: formData.email,
//            phoneNumber: formData.phoneNumber,
//            description: formData.message,
//            termsAccepted: formData.termsAccepted,
//          }
//        );

//        console.log("Contact added successfully:", response.data);

//        setFormData({
//          fullName: "",
//          email: "",
//          phoneNumber: "",
//          message: "",
//          termsAccepted: false,
//        });
//        setUserInput("");
//        setIsChecked(false);

//        // Generate new captcha
//        const newCaptcha = generateCaptcha();
//        setCaptchaText(newCaptcha);

//        alert("Form submitted successfully!");
//      } catch (error) {
//        console.error("Error adding contact:", error);
//      }
//    }
//  };

//  const handleCheckboxChange = () => {
//    setIsChecked(!isChecked);
//  };

//  function handleInputChange(event) {
//    setUserInput(event.target.value);
//  }

//  function toggleModal() {
//    setShowModal(!showModal);
//  }

//  const refreshCaptcha = () => {
//    const newCaptcha = generateCaptcha();
//    setCaptchaText(newCaptcha);
//    setUserInput("");
//    setCaptchaError("");
//  };

//  return (
//    <div className="py-20" id="#hoa-contact">
//      <div className="flex flex-wrap bg-blue-800 shadow-[5px_25px_20px_6px_rgba(30,58,138,0.15)] justify-between p-[30px_50px] flex-col lg:flex-row lg:w-[85%] lg:mx-auto">
//        <div className="flex justify-center items-center text-white text-start gap-9 w-full text-center lg:text-start lg:w-1/2 pb-12 lg:pb-0">
//          <h2 className="w-full text-3xl sm:text-4xl lg:text-5xl font-black">
//            Start your HOA Plan with Us.
//          </h2>
//        </div>

//        <div className="flex justify-center items-center gap-9 w-full lg:w-1/2">
//          <form onSubmit={handleSubmit} className="flex flex-col justify-center items-start w-full">
//            <label htmlFor="fullName" className="text-white mb-2">Name *</label>
//            <input
//              type="text"
//              placeholder="Full Name"
//              name="fullName"
//              value={formData.fullName}
//              onChange={handleChange}
//              className="text-base mb-5 p-[10px_8px] border border-white rounded-[10px] outline-none bg-white text-black w-[300px] h-[50px] lg:w-[400px]"
//              maxLength={50}
//            />
//            {fullNameError && <p className="flex relative text-white -bottom-2.5 mb-2">{fullNameError}</p>}

//            <label htmlFor="email" className="text-white mb-2">Email *</label>
//            <input
//              type="email"
//              placeholder="Email"
//              name="email"
//              value={formData.email}
//              onChange={handleChange}
//              className="text-base mb-5 p-[10px_8px] border border-white rounded-[10px] outline-none bg-white text-black w-[300px] h-[50px] lg:w-[400px]"
//              maxLength={100}
//            />
//            {emailError && <p className="flex relative text-white -bottom-2.5 mb-2">{emailError}</p>}

//            <label htmlFor="phoneNumber" className="text-white mb-2">Phone Number *</label>
//            <PhoneInput
//              placeholder="Enter phone number"
//              value={formData.phoneNumber}
//              onChange={handlePhoneNumberChange}
//              defaultCountry="US"
//              containerClass="text-base p-0 mb-5 border-none rounded-[10px] outline-none w-[300px] lg:w-[400px]"
//              inputClass="phone-input"
//              country={'us'}
//              inputStyle={{
//                width: '100%',
//                height: '50px',
//                fontSize: '16px',
//                borderRadius: '10px',
//                border: '1px solid white',
//                outline: 'none',
//                backgroundColor: 'white',
//                color: 'black'
//              }}
//            />
//            {phoneNumberError && <p className="flex relative text-white -bottom-2.5 mb-2">{phoneNumberError}</p>}

//            <label htmlFor="message" className="text-white mb-2">Message *</label>
//            <textarea
//              placeholder="Message"
//              name="message"
//              value={formData.message}
//              onChange={handleChange}
//              className="text-base mb-5 p-[10px_8px] border border-white rounded-[10px] outline-none bg-white text-black w-[300px] h-[103px] lg:w-[400px] lg:h-[85px] resize-none"
//              maxLength={200}
//            />
//            {messageError && <p className="flex relative text-white -bottom-2.5 mb-2">{messageError}</p>}

//            <div className="w-full flex items-center gap-4 mb-2.5 flex-col sm:flex-row lg:flex-row">
//              <div className="flex-1 flex justify-center items-center bg-white rounded-lg p-2.5 shadow-[0_2px_8px_rgba(0,0,0,0.1)] w-full">
//                <canvas ref={canvasRef} className="rounded-md max-w-full h-auto"></canvas>
//              </div>

//              <div className="flex justify-center items-center">
//                <FontAwesomeIcon
//                  icon={faSync}
//                  onClick={refreshCaptcha}
//                  className="cursor-pointer text-2xl text-white bg-blue-800 p-3 rounded-lg transition-all duration-300 ease-in-out shadow-[rgba(50,50,93,0.25)_0px_50px_100px_-20px,rgba(0,0,0,0.3)_0px_30px_60px_-30px] hover:bg-blue-600 hover:rotate-180 hover:shadow-[rgba(50,50,93,0.35)_0px_60px_120px_-20px,rgba(0,0,0,0.4)_0px_40px_80px_-30px] active:rotate-[360deg]"
//                  title="Refresh Captcha"
//                />
//              </div>
//            </div>

//            <div className="w-full mb-2.5">
//              <input
//                type="text"
//                value={userInput}
//                onChange={handleInputChange}
//                placeholder="Enter Captcha"
//                className="w-[300px] lg:w-[400px] text-base mb-0 p-[10px_8px] border border-white rounded-[10px] outline-none bg-white text-black"
//                maxLength={6}
//              />
//            </div>
//            {captchaError && <p className="flex relative text-white -bottom-2.5 mb-2">{captchaError}</p>}

//            <div className="text-center flex justify-center items-center py-2.5">
//              <label htmlFor="terms" className="flex items-center justify-center gap-2.5 text-white cursor-pointer">
//                <div className="flex justify-center items-center">
//                  <input
//                    type="checkbox"
//                    id="terms"
//                    checked={isChecked}
//                    onChange={handleCheckboxChange}
//                    className="h-[15px] w-[15px] mb-0"
//                  />
//                </div>
//                <p className="mb-0">
//                  I agree to the{" "}
//                  <Link to="#" onClick={toggleModal} className="no-underline text-white hover:text-gray-200">
//                    Terms & Conditions
//                  </Link>
//                </p>
//              </label>
//            </div>
//            {termsError && <p className="flex relative text-white -bottom-2.5 mb-2">{termsError}</p>}

//            <div className="w-full flex justify-start lg:justify-end">
//              <button
//                type="submit"
//                className="py-2.5 px-5 bg-white text-blue-800 no-underline border-none cursor-pointer tracking-wider rounded-md text-base font-bold transition-all duration-300 ease-in-out hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(255,255,255,0.3)] active:translate-y-0"
//              >
//                Submit
//              </button>
//            </div>
//          </form>
//        </div>
//      </div>

//      {showModal && (
//        <div className="fixed z-[9999] left-0 top-0 w-full h-screen bg-black bg-opacity-70">
//          <div className="flex justify-center items-center absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-800 p-5 w-[85%] sm:w-1/2 lg:w-2/5">
//            <span
//              className="absolute top-2.5 right-5 text-3xl cursor-pointer text-white hover:text-gray-300"
//              onClick={toggleModal}
//            >
//              &times;
//            </span>
//            <HoaTermsConditions closeModal={toggleModal} />
//          </div>
//        </div>
//      )}
//    </div>
//  );
//};

//export default HoaContact;

import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faEnvelope, faPhone, faUser, faComments, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import HoaTermsConditions from "../HoaTermsConditions/HoaTermsConditions";
import axios from "axios";
import { API_URL } from "../../apiConfig";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const HoaContact = () => {
    const [showModal, setShowModal] = useState(false);
    const [userInput, setUserInput] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [captchaText, setCaptchaText] = useState("");
    const canvasRef = useRef(null);
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        message: "",
        termsAccepted: false,
    });

    const [errors, setErrors] = useState({});

    // Generate captcha text
    const generateCaptcha = () => {
        const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
        let result = '';
        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    };

    // Draw captcha on canvas
    const drawCaptcha = (text) => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        canvas.width = 200;
        canvas.height = 60;

        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Set gradient background
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#f8fafc');
        gradient.addColorStop(1, '#e2e8f0');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Add subtle noise lines
        for (let i = 0; i < 3; i++) {
            ctx.strokeStyle = `rgba(59, 130, 246, ${Math.random() * 0.2 + 0.1})`;
            ctx.lineWidth = Math.random() * 1.5 + 0.5;
            ctx.beginPath();
            ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.bezierCurveTo(
                Math.random() * canvas.width, Math.random() * canvas.height,
                Math.random() * canvas.width, Math.random() * canvas.height,
                Math.random() * canvas.width, Math.random() * canvas.height
            );
            ctx.stroke();
        }

        // Add subtle dots
        for (let i = 0; i < 20; i++) {
            ctx.fillStyle = `rgba(59, 130, 246, ${Math.random() * 0.3 + 0.1})`;
            ctx.beginPath();
            ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 1.5 + 0.5, 0, 2 * Math.PI);
            ctx.fill();
        }

        // Draw text with better styling
        ctx.font = 'bold 26px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const textWidth = canvas.width / text.length;
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const x = textWidth * i + textWidth / 2;
            const y = canvas.height / 2 + (Math.random() - 0.5) * 8;

            // Gradient color for each character
            const charGradient = ctx.createLinearGradient(x - 10, y - 10, x + 10, y + 10);
            charGradient.addColorStop(0, '#1e40af');
            charGradient.addColorStop(1, '#3b82f6');
            ctx.fillStyle = charGradient;

            // Add text shadow
            ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
            ctx.shadowBlur = 2;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;

            // Random rotation
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate((Math.random() - 0.5) * 0.3);
            ctx.fillText(char, 0, 0);
            ctx.restore();
        }

        // Reset shadow
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;

        // Add subtle border
        ctx.strokeStyle = '#cbd5e1';
        ctx.lineWidth = 1;
        ctx.strokeRect(0, 0, canvas.width, canvas.height);
    };

    // Initialize captcha
    useEffect(() => {
        const newCaptcha = generateCaptcha();
        setCaptchaText(newCaptcha);
    }, []);

    // Draw captcha when text changes
    useEffect(() => {
        if (captchaText) {
            drawCaptcha(captchaText);
        }
    }, [captchaText]);

    // Validation functions
    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Full Name validation
        if (formData.fullName.trim() === "") {
            newErrors.fullName = "Full Name is required";
            isValid = false;
        }

        // Email validation
        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email address";
            isValid = false;
        }

        // Phone Number validation
        if (formData.phoneNumber.trim() === "" || formData.phoneNumber.length < 10) {
            newErrors.phoneNumber = "Phone Number must be at least 10 digits";
            isValid = false;
        }

        // Message validation
        if (formData.message.trim() === "") {
            newErrors.message = "Message is required";
            isValid = false;
        }

        // Captcha validation
        if (userInput.trim() === "") {
            newErrors.captcha = "Please enter the captcha";
            isValid = false;
        } else if (userInput.toLowerCase() !== captchaText.toLowerCase()) {
            newErrors.captcha = "Captcha is incorrect. Please try again.";
            isValid = false;
        }

        // Terms validation
        if (!isChecked) {
            newErrors.terms = "You must accept the Terms & Conditions";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handlePhoneNumberChange = (value) => {
        setFormData({
            ...formData,
            phoneNumber: value,
        });

        // Clear error when user starts typing
        if (errors.phoneNumber) {
            setErrors(prev => ({
                ...prev,
                phoneNumber: ""
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            try {
                const response = await axios.post(
                    `${API_URL}/public/contacts/add`,
                    {
                        name: formData.fullName,
                        email: formData.email,
                        phoneNumber: formData.phoneNumber,
                        description: formData.message,
                        termsAccepted: formData.termsAccepted,
                    }
                );

                console.log("Contact added successfully:", response.data);

                setFormData({
                    fullName: "",
                    email: "",
                    phoneNumber: "",
                    message: "",
                    termsAccepted: false,
                });
                setUserInput("");
                setIsChecked(false);
                setErrors({});

                // Generate new captcha
                const newCaptcha = generateCaptcha();
                setCaptchaText(newCaptcha);

                alert("Form submitted successfully!");
            } catch (error) {
                console.error("Error adding contact:", error);
                alert("There was an error submitting your form. Please try again.");
            }
        }
    };

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);

        // Clear error when user checks the box
        if (errors.terms) {
            setErrors(prev => ({
                ...prev,
                terms: ""
            }));
        }
    };

    function handleInputChange(event) {
        setUserInput(event.target.value);

        // Clear error when user starts typing
        if (errors.captcha) {
            setErrors(prev => ({
                ...prev,
                captcha: ""
            }));
        }
    }

    function toggleModal() {
        setShowModal(!showModal);
    }

    const refreshCaptcha = () => {
        const newCaptcha = generateCaptcha();
        setCaptchaText(newCaptcha);
        setUserInput("");
        setErrors(prev => ({
            ...prev,
            captcha: ""
        }));
    };

    return (
        <div className="py-20 bg-gradient-to-br from-gray-50 to-gray-100" id="#hoa-contact">
            <div className="max-w-7xl mx-auto px-4">
                <div className="bg-gradient-to-br from-blue-800 to-blue-900 shadow-2xl rounded-2xl overflow-hidden">
                    <div className="flex flex-col">
                        {/* Top Section - Header Content */}
                        <div className="flex items-center justify-center p-8 sm:p-12 lg:p-16 bg-gradient-to-br from-blue-800/90 to-blue-900/90 backdrop-blur-sm border-b border-white/10">
                            <div className="text-center w-full px-4 sm:px-8 lg:px-12">
                                <div className="mb-8">
                                    <div className="p-4 bg-white/10 rounded-2xl backdrop-blur-sm inline-block mb-6">
                                        <FontAwesomeIcon icon={faEnvelope} className="w-8 h-8 text-white" />
                                    </div>
                                    <h1 className="text-2xl lg:text-4xl font-bold text-white mb-6 leading-tight">
                                        Start Your VHOAS Journey
                                    </h1>
                                    <p className="text-xl text-blue-100 leading-relaxed mb-8">
                                        Ready to streamline your community management? Get in touch with us today and discover how we can help transform your HOA experience.
                                    </p>
                                </div>
                                <div className="flex flex-col sm:flex-row justify-center items-center gap-8 text-blue-100">
                                    <div className="flex items-center gap-3">
                                        <FontAwesomeIcon icon={faPhone} className="w-5 h-5 text-blue-200" />
                                        <span>Professional HOA Management</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <FontAwesomeIcon icon={faShieldAlt} className="w-5 h-5 text-blue-200" />
                                        <span>Trusted by Communities Nationwide</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <FontAwesomeIcon icon={faComments} className="w-5 h-5 text-blue-200" />
                                        <span>24/7 Support & Service</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Bottom Section - Contact Form */}
                        <div className="p-8 sm:p-12 bg-white/5 backdrop-blur-sm">
                            <div className="w-full px-4 sm:px-8 lg:px-12">
                                <div className="mb-8">
                                    <h2 className="text-2xl font-bold text-white mb-2">Get Started Today</h2>
                                    <p className="text-blue-100">Fill out the form below and we'll get back to you within 24 hours.</p>
                                </div>

                                <form onSubmit={handleSubmit} className="space-y-6">
                                    {/* Name and Phone Row */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Name Field */}
                                        <div>
                                            <label htmlFor="fullName" className="block mb-2 text-sm font-medium text-blue-100">
                                                <FontAwesomeIcon icon={faUser} className="w-4 h-4 mr-2" />
                                                Full Name *
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter your full name"
                                                name="fullName"
                                                id="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                maxLength={50}
                                            />
                                            {errors.fullName && (
                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.fullName}
                                                </p>
                                            )}
                                        </div>

                                        {/* Phone Field */}
                                        <div>
                                            <label htmlFor="phoneNumber" className="block mb-2 text-sm font-medium text-blue-100">
                                                <FontAwesomeIcon icon={faPhone} className="w-4 h-4 mr-2" />
                                                Phone Number *
                                            </label>
                                            <PhoneInput
                                                placeholder="Enter phone number"
                                                value={formData.phoneNumber}
                                                onChange={handlePhoneNumberChange}
                                                defaultCountry="US"
                                                containerClass="w-full"
                                                inputClass="phone-input-custom"
                                                country={'us'}
                                                inputStyle={{
                                                    width: '100%',
                                                    height: '48px',
                                                    fontSize: '16px',
                                                    borderRadius: '12px',
                                                    border: '1px solid #d1d5db',
                                                    outline: 'none',
                                                    backgroundColor: 'white',
                                                    color: '#111827',
                                                    paddingLeft: '60px'
                                                }}
                                                buttonStyle={{
                                                    borderRadius: '12px 0 0 12px',
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: 'white'
                                                }}
                                            />
                                            {errors.phoneNumber && (
                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.phoneNumber}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Email Field - Full Width */}
                                    <div>
                                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-blue-100">
                                            <FontAwesomeIcon icon={faEnvelope} className="w-4 h-4 mr-2" />
                                            Email Address *
                                        </label>
                                        <input
                                            type="email"
                                            placeholder="Enter your email address"
                                            name="email"
                                            id="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                            maxLength={100}
                                        />
                                        {errors.email && (
                                            <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                {errors.email}
                                            </p>
                                        )}
                                    </div>

                                    {/* Captcha and Message Row */}
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
                                        {/* Enhanced Captcha Section */}
                                        <div className="flex flex-col">
                                            <label className="block mb-2 text-sm font-medium text-blue-100">
                                                <FontAwesomeIcon icon={faShieldAlt} className="w-4 h-4 mr-2" />
                                                Security Verification *
                                            </label>
                                            <div className="flex md:flex-row flex-col items-center gap-3 mb-4">
                                                <div className="flex gap-4 md:gap-0 flex-1">
                                                    <div className=" bg-white rounded-xl py-1 px-2 shadow-lg border-2 border-gray-200 flex-1">
                                                        <canvas
                                                            ref={canvasRef}
                                                            style={{ display: 'block', width: "120px" }}
                                                            className="rounded-lg  h-auto md:w-[120px] w-[200px]"
                                                        />
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={refreshCaptcha}
                                                        className="flex-shrink-0 p-3 bg-white/10 hover:bg-white/20 rounded-xl transition-all duration-200 border border-white/20 hover:border-white/40 group flex-1"
                                                        title="Generate new captcha"
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faSync}
                                                            className="w-5 h-5 text-white group-hover:rotate-180 transition-transform duration-300"
                                                        />
                                                    </button>
                                                </div>
                                                <div className="flex-1">
                                                    <input
                                                        type="text"
                                                        value={userInput}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter captcha "
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-center font-mono tracking-wider"
                                                        maxLength={6}
                                                    />
                                                </div>
                                                {errors.captcha && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.captcha}
                                                    </p>
                                                )}
                                            </div>

                                        </div>

                                        {/* Message Field */}
                                        <div className="flex flex-col h-full">
                                            <label htmlFor="message" className="block mb-2 text-sm font-medium text-blue-100">
                                                <FontAwesomeIcon icon={faComments} className="w-4 h-4 mr-2" />
                                                Message *
                                            </label>
                                            <textarea
                                                placeholder="Tell us how we can help..."
                                                name="message"
                                                id="message"
                                                rows={1}
                                                value={formData.message}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 bg-white border h-4 md:h-2 border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm resize-none flex-1"
                                                maxLength={200}
                                            />
                                            {errors.message && (
                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.message}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Terms & Conditions */}
                                    <div className="space-y-4">
                                        <div className="flex items-start gap-3">
                                            <div className="flex items-center h-6">
                                                <input
                                                    type="checkbox"
                                                    id="terms"
                                                    checked={isChecked}
                                                    onChange={handleCheckboxChange}
                                                    className="w-5 h-5 text-blue-600 bg-white border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                />
                                            </div>
                                            <label htmlFor="terms" className="text-sm text-blue-100 leading-relaxed cursor-pointer">
                                                I agree to the{' '}
                                                <Link
                                                    to="#"
                                                    onClick={toggleModal}
                                                    className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
                                                >
                                                    Terms & Conditions
                                                </Link>
                                                {' '}and understand how my information will be used.
                                            </label>
                                        </div>
                                        {errors.terms && (
                                            <p className="text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                {errors.terms}
                                            </p>
                                        )}
                                    </div>

                                    {/* Submit Button */}
                                    <div className="pt-4">
                                        <button
                                            type="submit"
                                            className="w-full px-8 py-4 bg-white hover:bg-gray-100 text-blue-800 font-bold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform text-lg"
                                        >
                                            Send Message
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Enhanced Modal */}
            {showModal && (
                <div className="fixed z-[9999] inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="relative bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
                        <div className="flex items-center justify-between p-6 border-b border-white/10">
                            <h3 className="text-xl font-bold text-white">Terms & Conditions</h3>
                            <button
                                onClick={toggleModal}
                                className="p-2 hover:bg-white/10 rounded-lg transition-colors duration-200"
                            >
                                <span className="text-2xl text-white hover:text-gray-300">&times;</span>
                            </button>
                        </div>
                        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
                            <HoaTermsConditions closeModal={toggleModal} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HoaContact;